import { createContext, useContext, useEffect, useState } from "react";

// Create Context
const DashboardDataContext = createContext();

// Provider
export const DashboardDataProvider = ({ children }) => {
  const [navbarFixed, setNavbarFixed] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const [isThemeDirection, setIsThemeDirection] = useState(false);
  const [topNavbarBgColor, setTopNavbarBgColor] = useState("black");

  // Theme Direction (LTR / RTL)
  useEffect(() => {
    document.body.setAttribute(
      "data-theme-direction",
      isThemeDirection ? "rtl" : "ltr"
    );
  }, [isThemeDirection]);

  // Dark / Light Mode
  useEffect(() => {
    document.body.setAttribute(
      "data-theme",
      isDark ? "dark" : "light"
    );
  }, [isDark]);

  return (
    <DashboardDataContext.Provider
      value={{
        navbarFixed,
        setNavbarFixed,
        isDark,
        setIsDark,
        isThemeDirection,
        setIsThemeDirection,
        topNavbarBgColor,
        setTopNavbarBgColor,
      }}
    >
      {children}
    </DashboardDataContext.Provider>
  );
};

// Custom Hook
export const useDashboardDataContext = () => {
  const context = useContext(DashboardDataContext);

  if (!context) {
    throw new Error(
      "useDashboardDataContext must be used within DashboardDataProvider"
    );
  }

  return context;
};